export default "__VITE_ASSET__DPx6Q8iY__"